import { MenuItemDef } from "ag-grid-community";
import { Subject } from "rxjs";
import ModuleDataGroupItem from "src/shared/models/module-data-group-item";
import type MetricData from "src/AngularJS/Models/metric-data";
import { ClearViewUtils } from "src/shared/utils";
import { TasksService } from "src/app/dashboard/modules/tasks/tasks.service";
import { CvApiServiceBase } from "./cv-api-service-base";

export class AgContextMenuServiceBase {
    // individual factories set the permissions here. can use getter if necessary
    public hasPermission = {
        IntervalReport: true,
        ProfilePreview: true,
        AgentStateDetails: true,
        SuggestCoaching: false,
        GiveAward: true,
        ForceLogout: true,
        Terminate: true,
        CreateTask: false,
        DetailLevelView: false,
        ExportSingleRow: true,
    };

    public intervalReportClicked = new Subject<GroupContextMenuParams>();
    public summaryReportClicked = new Subject<GroupContextMenuParams>();
    public profilePreviewClicked = new Subject<GroupContextMenuParams>();
    public agentDetailsClicked = new Subject<GroupContextMenuParams>();
    public suggestCoachingClicked = new Subject<GroupContextMenuParams>();
    public giveAwardClicked = new Subject<GroupContextMenuParams>();
    public forceLogoutClicked = new Subject<GroupContextMenuParams>();
    public terminateClicked = new Subject<GroupContextMenuParams>();
    public createTaskClicked = new Subject<GroupContextMenuParams>();
    public singleRowExportClicked = new Subject<GroupContextMenuParams>();

    // method implemented in SpawnModulePreviewService. passed through here to have interop between Angular and AngularJS
    public createDetailLevelMenuItem: (params: MetricContextMenuParams) => MenuItemDef = null;

    constructor(fromSharedService: boolean = false, 
        private tasksService?: TasksService,
        private cvApiService?: CvApiServiceBase
        ) {
        if (fromSharedService)
            return AgContextMenuServiceBase.getServiceBase();
        if (!cvApiService)
            this.cvApiService = CvApiServiceBase.getServiceBase();

        if(this.cvApiService.apiToken){
            this.tasksService = this.tasksService ?? new TasksService();
            this.getCreateTaskPermission();
        }
    }

    static getServiceBase(): AgContextMenuServiceBase {
        return ClearViewUtils.getSharedService(AgContextMenuServiceBase, 'AgContextMenuServiceBase');
    }

    async getCreateTaskPermission()
    {
        const response = await this.tasksService.getCreateTaskPermission();
        this.hasPermission.CreateTask = response;
    }
}

export interface GroupContextMenuParams {
    moduleKey: string;
    groupData: ModuleDataGroupItem;
    moduleTypeId?: number;
    isParentAgGridModule?: boolean;
    format?: string;
    moduleName?: string;
}

export interface MetricContextMenuParams {
    moduleKey: string;
    groupData: ModuleDataGroupItem;
    metricData: MetricData;
}
